export { ChassisResourceModule } from './src/chassis-resource.module';
export { ResourceService } from './src/services/resource.service';
export * from './src/+state/resource.reducer';
export * from './src/+state/resource.actions';


// WEBPACK FOOTER //
// ./libs/chassis-resource/index.ts